import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { HeartHandshake } from "lucide-react";
import api from "../lib/api";
import { IconRenderer } from "../lib/icons";

const CATEGORIES = [
  { id: "needs", label: "Needs", cls: "cat-needs" },
  { id: "feelings", label: "Feelings", cls: "cat-feelings" },
  { id: "food", label: "Food", cls: "cat-food" },
  { id: "activities", label: "Activities", cls: "cat-activities" },
  { id: "health", label: "Health", cls: "cat-health" },
  { id: "people", label: "People", cls: "cat-people" },
];

export default function SharedBoard() {
  const { token } = useParams();
  const [board, setBoard] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/share-board/${token}`)
      .then((r) => setBoard(r.data))
      .catch(() => setError(true));
  }, [token]);

  return (
    <div data-testid="shared-board-page" className="min-h-screen bg-background">
      <header className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-2">
        <span className="w-10 h-10 rounded-2xl bg-primary grid place-items-center">
          <HeartHandshake size={24} strokeWidth={2.5} className="text-white" />
        </span>
        <span className="text-xl font-extrabold tracking-tight">RoutineBuddy</span>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8 pb-24">
        {error ? (
          <p data-testid="shared-error" className="bg-white rounded-3xl border-2 border-foreground/10 p-8 text-lg text-muted-foreground">
            This shared board link has expired or is invalid.
          </p>
        ) : !board ? (
          <p className="text-lg text-muted-foreground">Loading…</p>
        ) : (
          <>
            <h1 data-testid="shared-board-name" className="text-3xl sm:text-4xl font-extrabold tracking-tight">{board.name}</h1>
            <p className="mt-2 text-lg text-muted-foreground">A communication board shared with you from RoutineBuddy.</p>
            {CATEGORIES.map((c) => {
              const tiles = board.tiles.filter((t) => t.category === c.id);
              if (!tiles.length) return null;
              return (
                <div key={c.id} className="mt-8">
                  <h2 className="text-xl font-extrabold mb-3">{c.label}</h2>
                  <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                    {tiles.map((t, i) => (
                      <div key={i} data-testid={`shared-tile-${t.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className={`bg-white rounded-3xl border-2 ${c.cls} p-4 flex flex-col items-center gap-2`}>
                        <IconRenderer name={t.icon} size={44} />
                        <span className="text-lg font-extrabold text-center leading-tight">{t.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
            <Link to="/" data-testid="shared-cta" className="mt-10 w-full min-h-[64px] rounded-full bg-primary text-white text-xl font-bold flex items-center justify-center transition-transform duration-200 ease-out hover:-translate-y-px">
              Make your own board — free
            </Link>
          </>
        )}
      </main>
    </div>
  );
}
